import { Helmet } from "react-helmet-async";
import { BUSINESS_NAME, siteUrl } from "@/lib/seo";

interface FAQ {
  question: string;
  answer: string;
}

interface SEOHeadProps {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
  faqs?: FAQ[];
  noIndex?: boolean;
}

export function SEOHead({ title, description, canonical, ogImage = "https://plomberieexcellence.com/opengraph.jpg", faqs, noIndex = false }: SEOHeadProps) {
  const canonicalUrl = canonical.startsWith("http")
    ? siteUrl(new URL(canonical).pathname)
    : siteUrl(canonical);
  const faqSchema = faqs && faqs.length > 0
    ? JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map((faq) => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer,
          },
        })),
      })
    : null;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {noIndex && <meta name="robots" content="noindex,follow" />}
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={BUSINESS_NAME} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />
      </Helmet>
      {typeof window === "undefined" && faqSchema && (
        <script type="application/ld+json">{faqSchema}</script>
      )}
    </>
  );
}
